/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DurationBucket } from './durationBucket';

export interface CheckDurationsDto { 
    rootInstanceId?: string;
    totalDurationMs?: number;
    rules?: Array<DurationBucket>;
    files?: Array<DurationBucket>;
    source?: CheckDurationsDto.SourceEnum;
}
export namespace CheckDurationsDto {
    export type SourceEnum = 'MODULE_REPORTED' | 'STEP_CLOCK' | 'INSTANCE_CLOCK' | 'MIXED' | 'NONE';
    export const SourceEnum = {
        MODULEREPORTED: 'MODULE_REPORTED' as SourceEnum,
        STEPCLOCK: 'STEP_CLOCK' as SourceEnum,
        INSTANCECLOCK: 'INSTANCE_CLOCK' as SourceEnum,
        MIXED: 'MIXED' as SourceEnum,
        NONE: 'NONE' as SourceEnum
    };
}